<template>
  <div class="list">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="search_form">
        <el-form-item label="时间">
          <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-select
            class="selectWidth"
            v-model="search_form.FFeeType"
            clearable>
            <el-option :value="0" label="交易手续费"></el-option>
            <el-option :value="2" label="花呗贴息费"></el-option>
            <el-option :value="1" label="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input
            class="selectWidth"
            placeholder="请输入商户编号"
            clearable
            v-model="search_form.FMerchantId"
            auto-complete="off"></el-input>
        </el-form-item>
        <auth-button
          opt="search"
          :plain="true"
          @click.native="search"
          :loading="loading"
          icon="el-icon-search"
          label="查询"
          style="margin-bottom: 15px;"></auth-button>
        <auth-button opt="batch_apply" @click.native="batchApply" label="批量申请" icon="el-icon-upload2" style="margin-bottom: 20px"></auth-button>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        align="center"
        v-loading="loading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}"
        @selection-change="selectRows">
        <el-table-column
          type="selection"
          width="50"
          align="center">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fShopType"
          label="店铺类型"
          width="80"
          align="center"
          v-if="!isAgent">
          <template slot-scope="scope">
            <span>{{ scope.row.fShopType === 1? '总店': '分店' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fCreateTime"
          label="时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fFeeType"
          label="费用类型"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fFeeType | feeType }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fFeeDetail"
          label="费用明细"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAmount"
          label="开票金额（元）"
          width="120"
          align="center">
          <template slot-scope="scope">
            <span>{{ parseFloat(scope.row.fAmount / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="apply_invoice"
              type="text"
              label="申请开票"
              @click.native="applyInvoice(scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
    <el-dialog :visible.sync="applyDialogVisible" width="850px" title="申请开票" @close="closeViewDialog" :close-on-click-modal="false">
      <apply-form
        v-if="!single"
        @submit="submit"
        :submit-loading="submitLoading"
        :visible="applyDialogVisible"
        :ids="selectedIds"
        :amount="selectedAmount+''"
        :desc="selectedDesc.join(',')"
        :showInvoiceRemark="showInvoiceRemark"
        :selectedMerchantId="selectedMerchantId"></apply-form>
      <apply-form
        v-else
        @submit="submit"
        :submit-loading="submitLoading"
        :visible="applyDialogVisible"
        :ids="[selectedRow.fId]"
        :amount="parseFloat(selectedRow.fAmount * 100) / 100+''"
        :desc="selectedRow.fFeeDetail"
        :showInvoiceRemark="showInvoiceRemark"
        :selectedMerchantId="selectedMerchantId"></apply-form>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import applyForm from './applyForm'
import { invoiceList, applyInvoice } from '@/api/settle'
export default {
  name: 'ApplyInvoice',
  components: {
    dateRangePicker,
    pagination,
    applyForm
  },
  data () {
    return {
      loading: false,
      search_form: {
        FFeeType: '',
        FStartTime: '', // 开始时间
        FEndTime: '', // 结束时间
        FMerchantId: ''// 商户编号

      },
      creatTime: [], // 创建时间
      list: [],
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      applyDialogVisible: false, // 发票弹窗是否显示
      selectedIds: [], // 选中的费用记录id
      selectedAmount: 0, // 选中的费用总数
      selectedDesc: [], // 选中的描述
      submitLoading: false,
      isAgent: true, // 是否是代理商
      sameMerchant: true, // 是否是同一个商户
      selectedRow: {}, // 选中的单个发票
      single: false, // 是否是单独发票
      showInvoiceRemark: false,
      selectedMerchantId: '' // 选中数据商户id
    }
  },
  mounted () {
    const roleId = this.$store.getters.roleId
    if (roleId === 1 || roleId === 3) {
      this.isAgent = true
    } else {
      this.isAgent = false
    }
    this.getList()
  },
  filters: {
    feeType (value) {
      let result
      switch (value) {
        case 0:
          result = '交易手续费'
          break
        case 2:
          result = '花呗贴息费'
          break
        default:
          result = '其他'
      }
      return result
    }
  },
  methods: {
    /**
         * @description 日期组件选中事件
         * @param  {String} value 当前结果
         */
    dateChange (value) {
      this.creatTime = value
    },
    /**
         * @description 点击查询
         */
    search () {
      this.paginations.pageNo = 1
      this.getList()
    },
    /**
         * @description 列表请求
         */
    getList () {
      this.search_form.FStartTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.search_form.FEndTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      const that = this
      that.loading = true
      const data = qs.stringify(Object.assign({}, this.search_form, this.paginations))
      invoiceList(data).then(response => {
        that.loading = false
        if (response.error_code === '0') {
          that.paginations.count = response.data.totalCount
          that.list = response.data.list
          that.showInvoiceRemark = response.data.agentIds && response.data.agentIds.includes(that.$store.getters.userId)
        } else {
          that.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 清除对象中无值属性
         */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
         * @description 改变当前页事件
         * @param  {Object} value 当前结果
         */
    onChangeCurrentPage (value) {
      this.paginations.pageNo = value
      this.getList()
    },
    /**
         * @description 申请发票
         * @param  {Object} value 当前行
         */
    applyInvoice (row) {
      this.selectedRow = row
      this.selectedMerchantId = row.fMerchantId
      this.applyDialogVisible = true
      this.single = true
    },
    /**
         * @description 关闭弹窗
         */
    closeViewDialog () {
      this.applyDialogVisible = false
      this.readOnly = false
    },
    /**
         * @description 表格选择修改时间
         * @param  {Object} selection 选中对象
         */
    selectRows (selection) {
      const that = this
      that.selectedIds = []
      that.selectedDesc = []
      that.selectedAmount = 0
      that.sameMerchant = true
      if (selection.length > 0) {
        const merchantId = selection[0].fMerchantId
        that.selectedMerchantId = merchantId
        selection.map(function (item) {
          if (item.fMerchantId !== merchantId) that.sameMerchant = false
          that.selectedIds.push(item.fId)
          that.selectedDesc.push(item.fFeeDetail)
          that.selectedAmount += parseFloat(item.fAmount * 100) / 100
        })
      }
    },

    /**
         * @description 表单校验
         */
    submit (form) {
      const that = this
      let param = form
      delete param.fUpdateTime
      delete param.fCreateTime
      param.fInvoiceId = typeof form.fInvoiceId === 'string' ? form.fInvoiceId : form.fInvoiceId.join(',')
      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.submitLoading = true
        param = qs.stringify(that.dismissBlank(param))
        applyInvoice(param).then(data => {
          that.submitLoading = false
          if (data.error_code === '0') {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.applyDialogVisible = false
            that.getList()
            that.single = false
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          that.submitLoading = false
        })
      }).catch(() => {

      })
    },
    /**
         * @description 删除对象中字符串的空格
         * @param  {number} params 目标对象
         */
    dismissBlank (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
          const element = params[key]
          if (typeof element === 'string') {
            params[key] = element.replace(/ /g, '')
          }
        }
      }
      return params
    },
    /**
         * @description 批量申请发票
         */
    batchApply () {
      if (this.selectedIds.length === 0) {
        this.$message({
          message: '请先选择同一个商户的费用记录',
          type: 'warning'
        })
        return
      }
      if (!this.sameMerchant) {
        this.$message({
          message: '请先筛选同一个商户，方可申请批量开票',
          type: 'warning'
        })
      } else {
        this.applyDialogVisible = true
        this.single = false
      }
    }
  }
}
</script>

<style scoped>
    .list{
        padding-left: 16px;
    }
    .pagination {
        display: inline-block;
    }
</style>
